import { render, staticRenderFns } from "./agv-ri-delivery.vue?vue&type=template&id=2259cc04&scoped=true&lang=pug&"
import script from "./agv-ri-delivery.vue?vue&type=script&lang=js&"
export * from "./agv-ri-delivery.vue?vue&type=script&lang=js&"
import style0 from "./agv-ri-delivery.vue?vue&type=style&index=0&id=2259cc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259cc04",
  null
  
)

export default component.exports